<template>
  <ul class="catalog-list">
    <li v-for="catalog in catalogs" :key="catalog.id" class="catalog-list__item">
      <a
        @click="
          $router.push({
            name: 'editCatalog',
            params: { id: catalog.id, module: catalog.type },
          })
        "
      >
        {{ catalog.name }}
      </a>
    </li>
    <li v-if="hasMissingCatalog" class="catalog-list__item--add">
      <a @click="$router.push('/catalogs')">
        <b-icon icon="playlist-plus"></b-icon>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    company: {
      type: Object,
      required: true,
    },
  },

  computed: {
    catalogs() {
      const { catalog, catalog_fits, catalog_modular, catalog_insole } = this.company
      const catalogList = []
      if (catalog) {
        catalogList.push(catalog)
      }
      if (catalog_fits) {
        catalogList.push(catalog_fits)
      }
      if (catalog_modular) {
        catalogList.push(catalog_modular)
      }
      if (catalog_insole) {
        catalogList.push(catalog_insole)
      }

      return catalogList
    },
    hasMissingCatalog() {
      const company = this.company
      const isTailored =
        company.moduleTailored ||
        (!company.moduleTailored && !company.moduleFits && !company.moduleModular && !company.moduleInsole)
      return (
        (isTailored && !company.catalog) ||
        (company.moduleFits && !company.catalog_fits) ||
        (company.moduleModular && !company.catalog_modular) ||
        (company.moduleInsole && !company.catalog_insole)
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.catalog-list {
  display: flex;
  flex-wrap: wrap;
  &__item:after {
    content: ',';
    margin-right: 5px;
  }
  &__item:last-child:after {
    content: '';
  }
}

span {
  color: #008a6b;
}
</style>
